import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FarmTypeForm from '../../../components/forms/FarmTypeForm';
import { useFarmTypeApi } from '../../../hooks/useFarmTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { FarmTypeDTO } from '../../../services/apiClient';

const FarmTypeEdit: React.FC = () => {
  const { getById, edit } = useFarmTypeApi();
  const [entityData, setEntityData] = useState<FarmTypeDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Farm Types', href: '/admin/farmtypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching FarmType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/farmtypes');
    } catch (error) {
      console.error('Error updating FarmType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/farmtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.FarmType.Edit"
    >
      {entityData ? (
        <FarmTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/farmtypes')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default FarmTypeEdit;
